import WifiBoxAdd from "./WifiBoxAdd";

export default WifiBoxAdd;
